import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7b83d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Realistischer Schätzwert", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "für deine Immobilie", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Kostenlose Online-Bewertung in 3 Min", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_single_line_address = _resolveComponent("single-line-address")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["single-line-address-banner", [`type--${_ctx.type}`, _ctx.layout]])
  }, [
    (_ctx.logo)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "logo",
          alt: _ctx.platform + ' ' + 'logo'
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_single_line_address, {
      class: "single-line-address",
      layout: _ctx.layout,
      target: _ctx.target,
      platform: _ctx.platform,
      "floating-button": _ctx.floatingButton || _ctx.defaultFloatingButtonLabel,
      "no-floating-button": _ctx.noFloatingButton,
      "m-tracking": _ctx.mTracking
    }, null, 8, ["layout", "target", "platform", "floating-button", "no-floating-button", "m-tracking"])
  ], 2))
}